import { render, staticRenderFns } from "./BaseAttachments.vue?vue&type=template&id=1f988044&scoped=true"
import script from "./BaseAttachments.vue?vue&type=script&lang=js"
export * from "./BaseAttachments.vue?vue&type=script&lang=js"
import style0 from "./BaseAttachments.vue?vue&type=style&index=0&id=1f988044&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f988044",
  null
  
)

export default component.exports